/**
 * @author Aydin Cinar
 */

var engelsizyasam = engelsizyasam || {};

(function(app) {
    app.classes = {
        current:    'current',
        hidden:     'is-hidden',
        transition: 'has-transition',
        scale0:     'scale0',
        scale1:   'scale100'
    };

    app.namespace = 'engelsizyasam';

    app.events = {
        click: 'click.' + app.namespace
    };

    app.$objs   = {};
    app.modules = [];

    app.registerInit = function(module) {
        app.modules.push(module);
    };

    app.init = function() {
        app.$objs.document = $(document);
        app.$objs.body     = $('body');

        app.initModules();
    };

    app.initModules = function() {
        if(app.modules.length > 0) {
            app.modules.forEach(function(module) {
                if(typeof app[module] !== 'undefined' && !app[module].isInitialized()) {
                    app[module].init();
                }
            });
        }
    };

    app.isMediumScreen = function() {
        return window.innerWidth >= 768 && window.innerWidth <= 1024;
    };

    app.isWideScreen = function() {
        return window.innerWidth > 1024;
    };
})(engelsizyasam);

$(function() {
    engelsizyasam.init();
});